import { getCopy } from '../utils/copy';
import { getExplainer } from './explainers';
import { speciesEmoji, teachLine } from '../utils/guardian';

/**
 * 学习胶囊: 30 秒知识提示,≤3 句话,无公式无长文
 *
 * 题目配了图解模板(puzzle.params.explainer)时,改为播放可动手的分步动画,
 * 数字取自这道题本身;没配或模板未知时退回文字提示。
 * 讲解的是孩子自己的灵兽(species),不是固定的猴子。
 */
function LearningCapsule({ hint, explainer, species, onContinue, ageBand }) {
  const Explainer = explainer ? getExplainer(explainer.template) : null;
  const emoji = species ? speciesEmoji(species) : '✨';

  if (Explainer) {
    return (
      <div className="flex flex-col items-center gap-4 rounded-2xl border-2 border-black bg-white p-6 shadow-brutal">
        <span className="text-5xl">{emoji}</span>
        <p className="text-center text-base font-medium text-gray-700">{teachLine(species, ageBand)}</p>
        <Explainer {...explainer.args} ageBand={ageBand} onDone={onContinue} />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border-2 border-black bg-white p-4 shadow-brutal sm:p-8">
      <span className="animate-bounce text-6xl">{emoji}</span>
      <p className="text-center text-lg font-medium text-gray-800">{hint}</p>
      <button
        type="button"
        onClick={onContinue}
        className="rounded-lg bg-qiji-gold px-6 py-3 text-base font-bold text-gray-900
                   border-2 border-black shadow-brutal-sm transition
                   hover:-translate-y-0.5 active:translate-y-0 active:shadow-none"
      >
        {getCopy(ageBand).capsuleButton}
      </button>
    </div>
  );
}

export default LearningCapsule;
